export default {"src":"https://cloudflare.edhrec.com/_next/static/media/spellify_icon.24d048cf.svg","height":330,"width":330,"blurWidth":0,"blurHeight":0};